var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import client from "@irati/utils/services/apollo";
import API from "@irati/utils/services/API";
import endpoints from "../endpoints";
import productPermissionsForTenantQuery from "./queries/ProductPermissionsForTenant";
import productPermissionsForTeamQuery from "./queries/ProductPermissionsForTeam";
var SwitchBoardService = /** @class */ (function () {
    function SwitchBoardService() {
        this.update = function (_a, etag) {
            var tenantId = _a.tenantId, data = __rest(_a, ["tenantId"]);
            return API.post(endpoints.switchboard() + "/" + tenantId, data, { etag: etag });
        };
        this.get = function (tenant, product, fetchPolicy) {
            if (fetchPolicy === void 0) { fetchPolicy = "network-only"; }
            var variables = {
                tenantId: tenant.uuid
            };
            return client
                .query({ query: productPermissionsForTenantQuery, variables: variables, fetchPolicy: fetchPolicy })
                .then(function (_a) {
                var data = _a.data;
                return data.permissionsForTenant[product];
            });
        };
        this.getForTeam = function (tenant, team, product, fetchPolicy) {
            if (fetchPolicy === void 0) { fetchPolicy = "network-only"; }
            var variables = {
                tenantId: tenant.uuid,
                teamId: team.uuid
            };
            return client
                .query({ query: productPermissionsForTeamQuery, variables: variables, fetchPolicy: fetchPolicy })
                .then(function (_a) {
                var data = _a.data;
                return data.permissionsForTeam.permissions[product];
            });
        };
    }
    return SwitchBoardService;
}());
var service = new SwitchBoardService();
export var updatePermissions = service.update;
export var getPermissions = service.get;
export var getPermissionsForTeam = service.getForTeam;
export default service;
